/*
  TW002 最低注文数ガード（2026-11-04）
  - TW002（handle: infinity-tw002）は「同じカラーで6着以上」からご購入いただけます
  - カート内のTW002をカラー（ラインアイテムのプロパティ「カラー」）ごとに合計し、
    6着未満のカラーがあればチェックアウトボタンを止めて案内を出す
  - カートページ・カートドロワーの両方に効く
*/
(function () {
  var HANDLE = 'infinity-tw002';
  var MIN = 6;
  var COLOR_KEY = 'カラー';
  var state = { blocked: false, shortages: [] };

  function check() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var groups = {};
        (cart.items || []).forEach(function (it) {
          if (it.handle !== HANDLE) return;
          var c = (it.properties && it.properties[COLOR_KEY]) || 'カラー未選択';
          groups[c] = (groups[c] || 0) + it.quantity;
        });
        var shortages = [];
        Object.keys(groups).forEach(function (c) {
          if (groups[c] < MIN) shortages.push({ color: c, qty: groups[c] });
        });
        state.blocked = shortages.length > 0;
        state.shortages = shortages;
        apply();
      })
      .catch(function () {});
  }

  function messageHtml() {
    var rows = state.shortages.map(function (s) {
      return '<li>' + s.color + '：現在' + s.qty + '着（あと' + (MIN - s.qty) + '着）</li>';
    }).join('');
    return '<p style="margin:0 0 4px;font-weight:700;">TW002は同じカラーで' + MIN + '着以上からご購入いただけます</p>' +
      '<ul style="margin:0;padding-left:1.2em;">' + rows + '</ul>' +
      '<p style="margin:4px 0 0;">サイズ違い・納期違いは同じカラーとして合算されます。</p>';
  }

  function apply() {
    var buttons = document.querySelectorAll('[name="checkout"]');
    buttons.forEach(function (btn) {
      if (state.blocked) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('data-tw002-blocked', '1');
      } else if (btn.getAttribute('data-tw002-blocked')) {
        btn.removeAttribute('disabled');
        btn.removeAttribute('data-tw002-blocked');
      }
      var box = btn.parentNode && btn.parentNode.querySelector('.tw002-minqty-msg');
      if (state.blocked) {
        if (!box) {
          box = document.createElement('div');
          box.className = 'tw002-minqty-msg';
          box.setAttribute('role', 'alert');
          var parentStyle = window.getComputedStyle(btn.parentNode);
          if (parentStyle.display.indexOf('flex') !== -1) btn.parentNode.style.flexWrap = 'wrap';
          box.style.cssText = 'flex:0 0 100%;width:100%;box-sizing:border-box;margin:0 0 12px;padding:12px 14px;background:#fff8f0;border:1px solid #e8c49a;border-left:4px solid #c0392b;font-size:13px;line-height:1.7;color:#4a3520;text-align:left;';
          btn.parentNode.insertBefore(box, btn);
        }
        var html = messageHtml();
        if (box.innerHTML !== html) box.innerHTML = html;
      } else if (box) {
        box.remove();
      }
    });
    document.querySelectorAll('.additional-checkout-buttons, .cart__dynamic-checkout-buttons, [data-shopify="dynamic-checkout-cart"]').forEach(function (el) {
      el.style.display = state.blocked ? 'none' : '';
    });
  }

  // チェックアウトへの送信を止める（ボタンの disabled が外された場合の保険）
  document.addEventListener('submit', function (e) {
    if (!state.blocked) return;
    var submitter = e.submitter;
    var form = e.target;
    var toCheckout = (submitter && submitter.name === 'checkout') ||
      (form && form.action && form.action.indexOf('/checkout') !== -1);
    if (toCheckout) { e.preventDefault(); e.stopPropagation(); apply(); }
  }, true);
  document.addEventListener('click', function (e) {
    if (!state.blocked) return;
    var a = e.target.closest && e.target.closest('a[href*="/checkout"]');
    if (a) { e.preventDefault(); e.stopPropagation(); apply(); }
  }, true);

  // カートが変わったら再チェック
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(check, 300); });
    }
    return p;
  };

  // ドロワー等の再描画でボタンが差し替わったら状態を再適用
  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(apply, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
})();
